<template>
	<div class="h-120rpx flex items-center justify-between bg-#0F0F17">
		<div @click="reToPage(item.key)" v-for="(item, index) in menuList" class="flex-1 flex flex-col items-center justify-center">
			<img v-if="activeMenu === item.key" class="w-46rpx h-46rpx" :src="item.activeIcon" alt="">
			<img v-else class="w-46rpx h-46rpx" :src="item.icon" alt="">
			<span class="mt-4rpx text-20rpx" :class="[activeMenu === item.key ? 'text-white' : 'text-#999']">{{
				$t(item.nameKey) }}</span>
		</div>
	</div>
</template>

<script>
import utils from "@/utils/utils.js";
export default {
	components: {
	},
	props: {
		activeMenu: {
			type: String,
			default: ''
		},
	},
	data() {
		return {
			menuList: [
				{
					id: 1,
					nameKey: '菜单.首页',
					key: 'home',
					// 使用require导入图片
					icon: require('@/assets/images/common/menu/home.png'),
					activeIcon: require('@/assets/images/common/menu/home_active.png'),
					path: "/home"
				},
				{
					id: 2,
					nameKey: '菜单.节点',
					key: 'node',
					icon: require('@/assets/images/common/menu/node.png'),
					activeIcon: require('@/assets/images/common/menu/node_active.png'),
					path: "/node"
				},
				{
					id: 3,
					nameKey: '菜单.生态',
					key: 'ecology',
					icon: require('@/assets/images/common/menu/ecology.png'),
					activeIcon: require('@/assets/images/common/menu/ecology_active.png'),
					path: "/ecology"
				},
				{
					id:4,
					nameKey: '菜单.团队',
					key: 'team',
					icon: require('@/assets/images/common/menu/team.png'),
					activeIcon: require('@/assets/images/common/menu/team_active.png'),
					path: "/team"
				},
				{
					id: 5,
					nameKey: '菜单.个人',
					key: 'me',
					icon: require('@/assets/images/common/menu/me.png'),
					activeIcon: require('@/assets/images/common/menu/me_active.png'),
					path: "/me"
				},

			]
		};
	},
	computed: {},
	created() { },
	methods: {
		reToPage(path) {
			console.log(path);
			utils.reToPage(path);
		},
	},
}
</script>

<style></style>
